/** Código de Postgres para `check_violation`. Lo usan los triggers de validación con un mensaje para el usuario. */
const CHECK_VIOLATION = '23514'

/** Texto que Postgres pone en el mensaje de una CHECK constraint. Está en inglés y no es para el usuario. */
const MENSAJE_CHECK_CONSTRAINT = 'violates check constraint'

/**
 * Texto para mostrarle al usuario cuando falla una operación contra la base.
 * Con un error 23514 de un trigger devuelve el mensaje del error. Con un 23514 de una CHECK
 * constraint, o con cualquier otro error, devuelve `fallback`.
 */
export const mensajeDeError = (error: unknown, fallback: string): string => {
  if (typeof error !== 'object' || error === null) return fallback
  const { code, message } = error as { code?: unknown; message?: unknown }
  if (code !== CHECK_VIOLATION || typeof message !== 'string' || !message) return fallback
  if (message.includes(MENSAJE_CHECK_CONSTRAINT)) return fallback
  return message
}
